/**
 * Whether the assistant may run a tool without asking first.
 *
 * Its own module, with no imports, so the surfaces that reset it at a session
 * boundary (`/login`, the demo sign-out) can read the default without pulling
 * the whole store in — their tests replace the store module wholesale.
 */
export type ChatApprovalMode = 'manual' | 'auto';

/**
 * What a page with no chat open starts on, and what a sign-out resets to.
 *
 * Manual, like the server's own default for a session with no mode stored: a
 * reader who has not chosen is asked before anything is saved or spent
 * (ENG-2616). New chat starts on the mode the reader last picked from the
 * badge, and on this only when they have picked none.
 */
export const DEFAULT_CHAT_APPROVAL_MODE: ChatApprovalMode = 'manual';
